import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=3c5e6c35&scoped=true&"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=3c5e6c35&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5e6c35",
  null
  
)

export default component.exports